import {
  Typography,
  Grid,
  List,
  ListItemIcon,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CircleIcon from "@mui/icons-material/Circle";
import { styles, sxStyles, iconStyle } from "./glossaryData.styles";

const iconEye = <RemoveRedEyeIcon style={iconStyle} />;

export const htaProtocolGlossaryData = (t) => ({
  rows: [
    {
      parameter: "name",
      detail: "complete_name_patient",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "antiquity",
      detail: "time_elapsed_enrollment",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "weight",
      detail: "weight_patient",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: { text: "measurements_date", subtext: "from_to" },
      detail: "data_fist_last_measurement",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("measurment_is")}</Grid>
          <Grid item>{t("examp_sense_from")}</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "measurement_quantity",
      detail: "amount_measurements",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("max_measurements")}</Grid>
          <Grid item> {t("max_measurements2")}</Grid>
          <Grid item> {t("exam")}:12/28</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "ta_average_day",
      detail: "show_pbd_average_pd",
      behavior: (
        <>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_lest_than")}&nbsp;
              <span style={styles.success}> 120 / 80</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_yellow")}&nbsp;
              <span style={styles.warning}> 140 / 80</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_red")}&nbsp;
              <span style={styles.error}> 190 / 100</span>
            </ListItemIcon>
          </List>
        </>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "ta_average_afernoon",
      detail: "show_average_bp",
      behavior: (
        <>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_lest_than")}&nbsp;
              <span style={styles.success}>120 / 80</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_yellow")}&nbsp;
              <span style={styles.warning}>140 / 90</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_red")}&nbsp;
              <span style={styles.error}>185 / 100</span>
            </ListItemIcon>
          </List>
        </>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "ta_average_general",
      detail: "four_daily_blood_pressure_measurements_average",
      behavior: (
        <>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_lest_than")}&nbsp;
              <span style={styles.success}>120 / 80</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_yellow")}&nbsp;
              <span style={styles.warning}>140 / 90</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_red")}&nbsp;
              <span style={styles.error}>185 / 100</span>
            </ListItemIcon>
          </List>
        </>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "hr_day_afternoon_average",
      detail: "average_bp_afternoon_last_seven_days",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("data_average_bpday_bpafternoon")}</Grid>
          <Grid item>{t("exam")}:95 / 98.</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "fc_general_average",
      detail: "show_average_fcg",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("average_within_range")}</Grid>
          <Grid item>{t("exam")}:95.</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "actions",
      detail: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6}>
              {t("see")} {iconEye} : {t("allows_you_see")}
            </Grid>
          </Grid>
        </Typography>
      ),
      behavior: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6} align="justify">
              {t("select_icon_ayes_redirect")}
            </Grid>
          </Grid>
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
  ],
  footerNote: "note",
});
